
import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import { Curious } from '@curi/react';
import __map from 'lodash/map';

import './HourOfCodeWrapper.css';
// import BrontoMailForm from '../../components/forms/BrontoMailForm';
import __isEmpty from 'lodash/isEmpty';
import { gtmPageviewEvent } from '../../services/google-tag-manager';
import Button from '../../components/elements/Button';
import Award from '../../components/global/Award';
const queryString = require('query-string');

const imgURL = process.env.REACT_APP_CLOUDFRONT_URL;

class HourOfCode extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      countries: [
        { name: 'English', flag: `${imgURL}/wp-transfer/US_UK.png`, pdf_url: `${imgURL}/dashboard/pdf/english/Hour_of_Code_Curriculum_2021.pdf` },
        { name: 'Simplified <br className="show-for-medium" />Chinese', flag: `${imgURL}/wp-transfer/China.png`, pdf_url: `${imgURL}/dashboard/pdf/chinese-simp/Hour_of_Code_Curriculum_2018_S_Chinese.pdf` },
        { name: 'Traditional <br className="show-for-medium" />Chinese', flag: `${imgURL}/wp-transfer/Taiwan%20Hong%20Kong.png`, pdf_url: `${imgURL}/dashboard/pdf/chinese-trad/Hour_of_Code_Curriculum_2018_Trad_Chinese.pdf` },
        { name: 'Spanish', flag: `${imgURL}/wp-transfer/Spain.png`, pdf_url: `${imgURL}/dashboard/pdf/spanish/Hour_of_Code_Curriculum_2018_Spanish.pdf` },
        { name: 'German', flag: `${imgURL}/wp-transfer/Germany.png`, pdf_url: `${imgURL}/dashboard/pdf/german/Hour_of_Code_Curriculum_2018_German.pdf` },
        { name: 'Japanese', flag: `${imgURL}/wp-transfer/Japan.png`, pdf_url: `${imgURL}/dashboard/pdf/japanese/Hour_of_Code_Curriculum_2018_Japanese.pdf` },
      //  { name: 'Korean', flag: 'https://thefoos-com.s3.amazonaws.com/wp-transfer/South-Korea.png', pdf_url: 'https://thefoos-com.s3.amazonaws.com/dashboard/pdf/korean/Hour_of_Code_Curriculum_2017_Korean.pdf' },
      //  { name: 'Italian', flag: 'https://thefoos-com.s3.amazonaws.com/wp-transfer/Italy.png', pdf_url: 'https://thefoos-com.s3.amazonaws.com/dashboard/pdf/italian/Hour_of_Code_Curriculum_2017_Italian.pdf' },
      //  { name: 'French', flag: 'https://thefoos-com.s3.amazonaws.com/wp-transfer/France.png', pdf_url: 'https://s3-us-west-2.amazonaws.com/thefoos-com/dashboard/pdf/french/Hour_of_Code_Curriculum_2017_French.pdf' },
      //  { name: 'Portuguese', flag: 'https://thefoos-com.s3.amazonaws.com/wp-transfer/Portugal.png', pdf_url: 'https://thefoos-com.s3.amazonaws.com/dashboard/pdf/portuguese/Hour_of_Code_Curriculum_2017_Portuguese.pdf' },
      //  { name: 'Dutch', flag: 'https://thefoos-com.s3.amazonaws.com/wp-transfer/Netherlands.png', pdf_url: 'https://s3-us-west-2.amazonaws.com/thefoos-com/dashboard/pdf/dutch/Hour_of_Code_Curriculum_2017_Dutch.pdf' },
      //  { name: 'Thai', flag: 'https://thefoos-com.s3.amazonaws.com/wp-transfer/Thailand.png', pdf_url: 'https://s3-us-west-2.amazonaws.com/thefoos-com/dashboard/pdf/thai/Hour_of_Code_Curriculum_2017_Thai.pdf' },
      //  { name: 'Russian', flag: 'https://thefoos-com.s3.amazonaws.com/wp-transfer/Russia.png', pdf_url: 'https://thefoos-com.s3.amazonaws.com/dashboard/pdf/russian/Hour_of_Code_Curriculum_2017_Russian.pdf' },
      //  { name: 'Swedish', flag: 'https://thefoos-com.s3.amazonaws.com/wp-transfer/Sweden.png', pdf_url: 'https://s3-us-west-2.amazonaws.com/thefoos-com/dashboard/pdf/swedish/Hour_of_Code_Curriculum_2017_Swedish.pdf' },
      ],
      is_popup_open: false,
      is_hoc_popup_open: true,
      is_hoc_available: true,
      is_snoopy_available: process.env.REACT_APP_SNOOPY_ENABLED,
    }
    this.blazy = null;
    this.closeHOCPopup = this.closeHOCPopup.bind(this);
  }


  componentDidMount() {
    gtmPageviewEvent({
      pageName: 'codespark.com: Hour of Code',
      componentProps: this.props,
    });

    const parsedQuery = queryString.parse(this.props.response.location.query);
    if(parsedQuery.hoc && parsedQuery.hoc.includes('true')) {
      window.location.replace(process.env.REACT_APP_CODESPARK_BASE_URL + '/play', '_blank');
      // if user is coming from hoc page and hoc is in the query do not show popup
      localStorage.setItem('hoc_email_submitted', true);
      this.setState({ is_hoc_popup_open: false });
    } else {
      // we don't want to show the popup if the user is coming from code.org
      // we don't want to show popup if the user has already seen/submitted
      const shouldShowPopup = __isEmpty(localStorage.getItem('hoc_email_submitted'));
      this.setState({ is_hoc_popup_open: shouldShowPopup });
      import('blazy').then((Blazy) => {
        this.blazy = new Blazy();
      });
    }
  }

  getEnglishCurriculum() {
    if(this.state.countries && this.state.countries.length > 0) {
      const englishPDF = this.state.countries.find(x=> x.name === 'English');
      if(englishPDF)
      {
        return englishPDF.pdf_url;
      }
    }
    // if not found return a default
    return `${imgURL}/dashboard/pdf/english/Hour_of_Code_Curriculum_2021.pdf`;
  }
  sendMPEvent(mpEvent) {
    try {
      this.context.mixpanel.track(mpEvent);
    } catch (e) {
      console.error(e);
    }
  }

  openDashboardRegister() {
    try {
      this.context.mixpanel.track('codespark.com: Hour of Code Teacher Dash Clicked');
    } catch (e) {
      console.error(e);
    }
    window.open(process.env.REACT_APP_DASHBOARD_BASE_URL + '/#/register', '_blank');
  }

  closeHOCPopup() {
    this.setState({ is_hoc_popup_open: false });
  }

  render() {
    const hocActivityStyle = this.state.is_snoopy_available === 'true' ? 'small-12 medium-4 cell activity-block' : 'small-12 medium-6 cell activity-block';
    return (
      <div className="hoc-page page">
        <Helmet>
          <title>Hour of Code - Coding for Kids | codeSpark</title>
          <meta name="description" content="Every year codeSpark participates in CSedWeek's Hour of Code events. Spend one hour learning the basics of programming with The Foos. Free Hour of Code curriculum for teachers. Parents can continue beyond the Hour of Code by downloading the app with over 1,000+ activities." />
          <meta name="keywords" content="Hour of code, free coding programs, coding for kids, kids apps, kids games, coding in the classroom, STEM" />
          <meta property="og:title" content="Coding Game for Kids - Try it Free!" />
          <meta property="og:description" content="Try the #1 learn-to-code app for kids ages 3-10. Used by over 20 million kids worldwide, kids learn coding basics with puzzles and build skills to make their own games." />
          <meta name="twitter:card" content="app" />
          <meta name="twitter:site" content="@codesparkapp" />
          <meta name="twitter:description" content="Try the #1 learn-to-code app for kids 4+. Used by over 20 Million kids, codeSpark teaches coding basics through creative play and game creation. Coding improves STEM, reading, and math skills." />
          <meta name="twitter:app:country" content="" />
          <meta name="twitter:app:id:iphone" content="" />
          <meta name="twitter:app:id:ipad" content="" />
          <meta name="twitter:app:id:googleplay" content="" />
        </Helmet>

        {/* show or hide Hour of Code content*/}
        <div style={this.state.is_hoc_available === true ? {} : { display: 'none' }} >
          <div className="grid-x grid-padding-x activities-section hoc-section">
            <div className="small-12 cell">
              <h2 className="section-title">FREE FOR TEACHERS AND PARENTS</h2>
            </div>
          </div>
          <br />
          <div className="grid-x grid-padding-x align-center header-details-container">
            <div className="small-12 medium-9 cell details">
              <img className="hoc-logo" src={`${imgURL}/flagship/hoc-logo.jpg`} alt="Hour of Code logo" />
              <p>
                Our { new Date().getFullYear() } Hour of Code activities are here! Start learning to code with any of our 3 activities. Perfect for beginners with no coding experience and intermediate coders. <br />
              </p>
            </div>
          </div>

          <div className="grid-x grid-padding-x activities-section hoc-section">
            <div className="small-12 cell">
              <h2 className="section-title">ACTIVITIES</h2>
            </div>
            <div className={hocActivityStyle}>
              <h4 className="activity-block--title">Beginner Coders</h4>
              <a href='#getting-started'>
                <img className="activity-block--image" src={`${imgURL}/flagship/hoc_screen_thefoos.jpg`} alt="Hour of Code Glitch screen"/>
              </a>
              <p className="activity-block--type">Puzzles</p>
              <p className="activity-block--description">
                Code for an hour with codeSpark! Kid coders will learn
              problem solving and logical thinking skills.</p>
            </div>
            <div className={hocActivityStyle}>
              <h4 className="activity-block--title">Beginner to Intermediate Coders</h4>
              <a href='#getting-started'>
                <img className="activity-block--image" src={`${imgURL}/flagship/HOC_screen_2_small.jpg`} alt="Hour of Code Naomi screen"/>
              </a>
              <p className="activity-block--type">Create Your Own Games</p>
              <p className="activity-block--description">
                Kids will design and code their very own game.
              They will learn how to test and debug to make the ultimate game.</p>
            </div>

            {/* snoopy */}
            <div className={hocActivityStyle} style={this.state.is_snoopy_available ==='true' ? {} : { display: 'none' }}>
              <h4 className="activity-block--title">Beginner to Intermediate Coders</h4>
              <a href='#getting-started'>
                <img className="activity-block--image b-lazy" src={`${imgURL}/flagship/HOC_screen_3.jpg`} alt="Snoopy Snow Brawl screen"/>
              </a>
              <p className="activity-block--type">Snoopy Snow Brawl</p>
              <p className="activity-block--description">
                This multi-player game lets kids test out their coding skills
                in a friendly snowball fight. Who will be the last bird standing?</p>
            </div>
            {/* end snoopy */}

          </div>



          <div className="activities-anchor" id="getting-started"></div>
          <div className="grid-x grid-padding-x get-started-section hoc-section">
            <div className="small-12 cell">
              <h2 className="section-title">HOW TO GET STARTED</h2>
            </div>

            <div className="small-12 cell step-blocks">
              <div className="start-step start-step--1">
                <div className="count">1</div>
                <div className="title">Get the FREE game</div>
                <ul className="download-links">
                  <li>
                    <a href="https://itunes.apple.com/app/id923441570">
                      <img src={`${imgURL}/wp-transfer/Download_on_the_App_Store_Badge.svg_-1-e1478818376748.png`} alt="Download from the App Store" />
                    </a>
                  </li>
                  <li>
                    <a href="https://play.google.com/store/apps/details?id=org.codespark.thefoos">
                      <img src={`${imgURL}/wp-transfer/Get_it_on_Google_play.svg_-1-e1478818411355.png`} alt="Download from the Google Play Store" />
                    </a>
                  </li>
                  <li>
                    <a href={`${process.env.REACT_APP_CODESPARK_BASE_URL}/play?` + this.props.response.location.query} className="k-white-text">
                      <img src={`${imgURL}/flagship/icon_desktop.png`} aria-hidden="true" alt="desktop icon" />
                      <span className="little">Play on your</span><br />Web Browser
                    </a>
                  </li>
                </ul>
              </div>
              <div><a href={`${process.env.REACT_APP_CODESPARK_BASE_URL}/play?` + this.props.response.location.query}>
                <img src={`${imgURL}/accounts/complete/playontheweb.png`} alt="Play on the web icon" className="khoc-web-button" />
                </a>
              </div>
              <div className="start-step start-step--2">
                <div className="count">2</div>
                <div className="title">Play &amp; Learn</div>
                <div className="centered-image">
                  <img src={`${imgURL}/flagship/tablet_perspective.png`} aria-hidden="true" alt="tablet perspsective" />
                </div>
              </div>
              <div className="start-step start-step--3">
                <div className="count">3</div><br />
                <div className="title">Certificate</div>
                <div className="centered-image">
                  <a href={`${imgURL}/flagship/codeSpark-hoc-certificate.pdf`} target="_blank">
                    <img src={`${imgURL}/flagship/nice_certificate.png`} aria-hidden="true" alt="certificate" />
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div className="grid-x grid-padding-x awards-section align-center">

            <div className="medium-3 cell">
              <Award
                awardCategory="Gold Award Winner"
                awardTitle="Parents&rsquo;<br aria-hidden='true' />Choice Award"
                awardType="Mobile Apps"
              />
            </div>
            <div className="medium-3 cell">
              <Award
                awardCategory="2016 Winner"
                awardTitle="KAPi<br aria-hidden='true' />Awards"
                awardType="Best Childrens<br aria-hidden='true' />Games"
                pullType={true}
              />
            </div>
            <div className="medium-3 cell">
              <Award
                awardCategory="Editor&rsquo;s Choice"
                awardTitle="Children&rsquo;s Tech<span class='chop-word'>nology</span> Review"
                awardType="Design Excellence"
              />
            </div>
            <div className="medium-3 cell">
              <Award
                awardCategory="2015 Winner"
                awardTitle="Tillywig Toy<br aria-hidden='true' />Awards"
                awardType="Brain Child Award"
              />
            </div>
          </div>
        </div>

        {/* end Hour of Code*/}


        <br /><br />
        <div className="grid-x grid-padding-x teacher-resources-section hoc-section" id="resources">
          <div className="small-12 cell intro-container">
            <h2 className="section-title">Teacher Resources</h2>
            <h3 className="resources-subtitle">Free for Teachers in North America</h3>
            <h3 className="resources-subtitle-2">MANAGE YOUR CLASS</h3>
            <Button text="GET STARTED" type="in-page" onClick={() => this.openDashboardRegister()} />
          </div>
          <div className="small-12 cell downloads-container">
            <div className="grid-x grid-padding-x">
              <div className="small-12 medium-6 large-4 cell downloads downloads--hoc">
                <a href={this.getEnglishCurriculum()} target="_blank" rel="noopener noreferrer">
                  <div className="download-block">
                    <div>
                      <img alt="" className="download-block--download-image" src={`${imgURL}/flagship/download_symbol.png`} aria-hidden="true" />
                    </div>
                    <div className="download-block--text">
                      <p className="download-block--type">Hour of Code <br className="show-for-medium" />Curriculum</p>
                    </div>
                  </div>
                </a>
              </div>
              <div className="small-12 medium-6 large-8 cell downloads downloads--full-exp">
                <a href={`${process.env.REACT_APP_DASHBOARD_BASE_URL}/dashboard/lessons`} target="_blank" rel="noopener noreferrer" onClick={() => this.sendMPEvent('codespark.com: Hour of Code Teacher Dash Clicked')}>
                  <div className="download-block">
                    <div>
                      <i className="fa fa-link download-block--link-icon" aria-hidden="true" />
                    </div>
                    <div className="download-block--text">
                      <p className="download-block--type">Full <br className="show-for-medium" />Curriculum</p>
                    </div>
                  </div>
                </a>
                <a href={`${process.env.REACT_APP_DASHBOARD_BASE_URL}/dashboard/resources/solution-guides`} target="_blank" rel="noopener noreferrer" onClick={() => this.sendMPEvent('codespark.com: Hour of Code Teacher Dash Clicked')}>
                  <div className="download-block">
                    <div>
                      <i className="fa fa-link download-block--link-icon" aria-hidden="true" />
                    </div>
                    <div className="download-block--text">
                      <p className="download-block--type">Solution <br className="show-for-medium" />Guide</p>
                    </div>
                  </div>
                </a>
                <a href={`${process.env.REACT_APP_DASHBOARD_BASE_URL}/dashboard/resources/downloadable-images`} target="_blank" rel="noopener noreferrer" onClick={() => this.sendMPEvent('codespark.com: Hour of Code Teacher Dash Clicked')}>
                  <div className="download-block">
                    <div>
                      <i className="fa fa-link download-block--link-icon" aria-hidden="true" />
                    </div>
                    <div className="download-block--text">
                      <p className="download-block--type">Foo <br className="show-for-medium" />Commands</p>
                    </div>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className="grid-x grid-padding-x beyond-teachers-section hoc-section" id="beyond-teachers-section">
          <div className="small-12 cell">
            <h2 className="section-title">Teachers: Beyond the <br className="show-for-medium" />Hour of Code</h2>
            <Button text="REGISTER" type="in-page" extraClass="alt-blue" onClick={() => this.openDashboardRegister()} />
          </div>
          <div className="small-12 cell beyond-bullets">
            <img alt="" className="diversion-image" src={`${imgURL}/flagship/foo_classroom.png`} aria-hidden="true" />
            <ul>
              <li>Teacher Dashboard to manage your classroom</li>
              <li>Unlock the full game for classroom use</li>
              <li>Full 10-lesson curriculum</li>
              <li>Solutions Guide for puzzles</li>
              <li>Unplugged Activities</li>
            </ul>
          </div>
        </div>
        <div className="grid-x grid-padding-x affirming-section">
          <div className="small-12 cell">
            <ul className="checkmarks">
              <li>
                <img alt="" src={`${imgURL}/flagship/foo_checkmark.png`} aria-hidden="true" />
                No Experience <br className="show-for-medium" />Required
                            </li>
              <li>
                <img alt="" src={`${imgURL}/flagship/foo_checkmark.png`} aria-hidden="true" />
                For Elementary School <br className="show-for-medium" />Girls and Boys
                            </li>
              <li>
                <img alt="" src={`${imgURL}/flagship/foo_checkmark.png`} aria-hidden="true" />
                Word-Free <br className="show-for-medium" />&amp; Self-Guided
                            </li>
            </ul>
          </div>
        </div>
        <div className="grid-x grid-padding-x beyond-parents-section hoc-section">
          <div className="small-12 medium-6 cell">
            <h2 className="section-title">Parents: Beyond the <br className="show-for-medium" />Hour of Code</h2>
            <Button text="START YOUR FREE TRIAL" type="in-page" onClick={(e) => this.props.goToLink(e, process.env.REACT_APP_ACCOUNTS_BASE_URL)} />
          </div>
          <div className="small-12 medium-6 cell beyond-bullets">
            <ul>
              <li>Hours of puzzles teach the ABC&rsquo;s of coding</li>
              <li>Developed for girls and boys ages 3-10</li>
              <li>Research-backed curriculum</li>
              <li>Code-your-own games</li>
              <li>Word-free learning for pre-readers and non-english speakers</li>
            </ul>
          </div>
          <div className="small-12 medium-10 align-center cell codeninja-info">
            <img className="codeninja-hoc" src={`${imgURL}/flagship/codeninjas_glitch.png`} alt="" />
            <div className="codeninja-blurb">
              <p>Code Ninjas will host free Hour of Code activities at participating locations across the country, including a fun "Holiday Hackathon" with awesome prizes!</p>
              <p>Visit
                <a href="https://www.codeninjas.com/" target="_blank" rel="noopener noreferrer"> codeninjas.com </a>
                for more information.
              </p>
            </div>
          </div>
          <div className="small-12 cell background-school"></div>
        </div>
      </div>

    );
  }
}

HourOfCode.contextTypes = {
  mixpanel: PropTypes.object
};

export default props => (
  <Curious>
    {({ router, response, navigation }) => {
      return <HourOfCode router={router} response={response} {...props} />;
    }}
  </Curious>
);



// WEBPACK FOOTER //
// ./src/containers/HourOfCode/index.js